import PropTypes from 'prop-types';

import CustomIcon from '../../../CustomIcons';

const AccountRegionButton = ({ clickHandler, arrowStatus, shortName, iconType }) => (
  <button onClick={clickHandler} className="header__col-2--btn header__btn flex-group" type="button" tabIndex={0}>
    <CustomIcon type={iconType} className="chevron-right" size="24" fill="#FFFFFF" />
    {!!shortName.length && <span>{shortName}</span>}
    <CustomIcon type={arrowStatus ? 'upArrow' : 'downArrow'} className="large_screen_only" size="24" fill="#FFFFFF" />
  </button>
);

AccountRegionButton.propTypes = {
  clickHandler: PropTypes.func.isRequired,
  arrowStatus: PropTypes.bool.isRequired,
  shortName: PropTypes.string,
  iconType: PropTypes.string.isRequired
};

AccountRegionButton.defaultProps = {
  shortName: ''
};

export default AccountRegionButton;
